import { render, staticRenderFns } from "./JobDetailContent.vue?vue&type=template&id=01ecd262&"
import script from "./JobDetailContent.vue?vue&type=script&lang=js&"
export * from "./JobDetailContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports